import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useFetcher from "@/utils/use-fetcher";

export interface CleanLineSheetImageParameter {
  agencyId: number;
  lineSheetSetId: number;
  lineSheetId: number;
}

export interface CleanLineSheetImageRequest {
  deleteAll?: boolean;
}

export interface CleanLineSheetImageResponse {}

export const cleanLineSheetImageTemplateUrl =
  "/agencies/:agencyId/line-sheet-sets/:lineSheetSetId/line-sheets/:lineSheetId/clean-product-image";

export const cleanLineSheetImageKey: YWRKey<CleanLineSheetImageParameter> = {
  url: (parameter: CleanLineSheetImageParameter) => {
    return calcUrl(cleanLineSheetImageTemplateUrl, parameter);
  },
  method: "put",
};

export default function useCleanLineSheetImage() {
  const fetcher = useFetcher<
    CleanLineSheetImageRequest,
    CleanLineSheetImageResponse
  >();
  return useYWR(cleanLineSheetImageKey, fetcher);
}
